
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
export const lang ={
  Please_set_materialtype_in_product_page:"Bitte gehen Sie zur Produktseite, um den Materialtyp jedes Produkts – Fertigprodukte – Halbfertigprodukte – Zubehör – zu ändern und festzulegen.",
  deleteAccount:"Ausloggen",
  deleteAccountWillDeleteAllData:"Wenn Sie sich von Ihrem Konto abmelden, werden alle Daten gelöscht und Sie können sich nicht mehr anmelden.",
  backupDatabase:"Backup-Datenbank",
  restoreDatabase:"Datenbank wiederherstellen",
  materialtype:"Materialtyp",
  Manufacturing:"Fertigungsversion",
  Professional:"Professionelle Version",
  Standard:"Standard Edition",
  product:"Fertiges Produkt",
  halfProduct:"Halbfertige Produkte",
  components:"Zubehör",
  Parent:"übergeordnete Komponente",
  Children:"Unterzubehör",
  Level:"Hierarchie",
  Timing:"Zeitliche Koordinierung",
  PieceCount:"Akkordarbeit",
  Wages:"Löhne",
  InternalProcess:"Interner Prozess",
  ExternalProcess:"Externer Prozess",
  ProceName:"Prozessname",
  ProceIndex:"Ausführungsauftrag",
  ChargeMan:"Rektor",
  BillMethod:"Abrechnungsmethode",
  ConsumTime:"Arbeitszeit",
  Accessories:"Zubehör",
  Assembly:"Montieren",
  materials:"Materialien",
  task:"Aufgabe",
  process:"Verfahren",
  BOM:"Stückliste",
  Production:"Produktion",
  RestorePurchaseOneUse:"Kauf wiederherstellen (ein Benutzer (beschränkt auf frühere Käufe))",
  buy_fail_try_again:"Bitte klicken Sie erneut, um zu kaufen",
  Export:"Export",
  Date:"Datum",
  BankDetail:"Bankdaten",
  Seller:"Verkäufer",
  Buver:"Käufer",
  Currency:"Währung",
  CompanyName:"Name der Firma",
  ProformaInvoice:"Proforma-Rechnung",
  Discount:"Rabatt",
  PayStatus:"Zahlungsstatus",
  ShippingStatus:"Versandstatus",
  FreightType:"Transportart",
  Shipping:"Fracht",
  Payment:"Zahlung",
  Moneyname:"Währungsname",
  Tax:"Steuern",
  Freight:"Frachtkosten",
  Insurance:"Versicherung",
  Bankfee:"Bankgebühren",
  Qc:"Qualitätszertifikat",
  Exchangerate:"Tauschrate",
  Shippingnumber:"Lieferungsnummer",
  ShipDate:"Versanddatum",
  Arrivedate:"Ankunftsdatum",
  Grossweight:"Bruttogewicht",
  CubicWeight:"Kubikgewicht",
  Totalpackages:"Gesamtzahl der Pakete",
  Moneytype:"Währungstyp",
  Quotedate:"Angebotsdatum",
  Validitydate:"Gültiges Datum",
  Paymentterm:"Ablauf des Entgelts",
  Priceterm:"Preisbedingung",
  DeliveryTerm:"Lieferzeit",
  BankName:"Bank Name",
  BankAddress:"Bankadresse",
  SwiftCode:"Bankleitzahl",
  Review:"Rezension",
  Signfor:"Unterschreiben Sie den Empfang",
  Finance:"Finanzen",
  Receiver:"Empfänger",
  Business:"Geschäft",
  ContactPerson:"Ansprechpartner",
  Profit:"profitieren",
  Staff_must_use_in_browser_please_check_the_address_in_help_page:"Mitarbeiter müssen Google Chrome verwenden. Bitte überprüfen Sie die IP-Adresse auf der Hilfeseite der Hauptdienstcomputer-APP und geben Sie die Adresse dann in die URL-Spalte anderer Computerbrowser ein, um die Anmeldung zu öffnen",
  newPassword:"Neues Kennwort",
  ForgetPassword:"vergessen Sie das Passwort",
  ContactUs:"Kontaktieren Sie uns/machen Sie Vorschläge",
  Actualpay_should_big_then_shouldpay:"Die tatsächlichen Einnahmen dürfen nicht größer sein als die Forderungen",
  ShopAddress:"Meine Shop-Adresse Scannen Sie den QR-Code, um eine Bestellung aufzugeben",
  Submit:"einreichen",
  All:"alle",
  OrdernumExists:"Bestellnummer existiert bereits",
  PermissionDenied:"Zugriff verweigert",
  StockTransfer:"Umlagerung",
  FromWarehouse:"Verlagerung aus dem Lager",
  ToWarehouse:"Übergabe an das Lager",
  PleaseUseInWebBrowser:"Bitte nutzen Sie die Export-Excel-Funktion in Google Chrome",
  PleasePrintInWebBrowser:"Bitte nutzen Sie die Druckfunktion in Google Chrome",
  HistoryPrice:"historischer Preis",
  SerialNumber:"Seriennummer",
  Please_Use_In_APP:"Bitte verwenden Sie es in Computersoftware",
  Please_Purchase_In_APP:"Bitte kaufen Sie innerhalb der APP, nicht im Browser",
  Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Sie können eine Verbindung zur Postgresql-Datenbank herstellen. Ihre Daten werden in der Postgresql-Datenbank gespeichert. Standardmäßig müssen Sie keine Verbindung zur Postgresql-Datenbank herstellen. Der Standardwert ist die lokale SQLite-Datenbank.",
  Connect_Postgresql_database_data_will_store_in_Postgresql:"Stellen Sie eine Verbindung zur Postgresql-Datenbank her. Ihre Daten werden in der Postgresql-Datenbank gespeichert und die Daten werden erneut gelesen",
  Use_sqlite_data_will_store_in_local:"Mithilfe von SQLite werden die Daten auf dem lokalen Computer gespeichert",
  UsePostgresqlDatabase:"Verwendung der PGSQL-Datenbank",
  UseSqliteDatabase:"Verwendung einer SQLite-Datenbank",
  DatabaseName:"Namensdatenbank",
  Test_connect:"Testverbindung",
  If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Wenn das Produkt eine Farbe oder Größe hat, geben Sie bitte 0 für den anfänglichen Lagerbestand ein. Nachdem Sie das Produkt hinzugefügt haben, geben Sie den Lagerbestand beim Kauf ein.",
  my:"meins",
  my_shop_qrcode_scan:"Der QR-Code meines Shops bietet Kunden die Möglichkeit, den Code zu scannen, um Bestellungen aufzugeben. Das Mobiltelefon des Kunden muss mit demselben Router wie Ihr Computer verbunden sein.",
  ip:"IP",
  port:"Hafen",
  orderstatus:"Bestellstatus",
  image:"Bild",
  Template:"Vorlage",
  Please_select_a_excel_file:"Bitte wählen Sie eine Datei aus",
  Please_select_only_one_excel_file:"Es kann nur eine Datei ausgewählt werden",
  Connect_Internet_Login_again:"Stellen Sie eine Verbindung zum Internet her und melden Sie sich vor dem Kauf erneut an",

productHasValidDate: 'Das Produkt hat einen gültigen Zeitraum',
productHasColor: 'Das Produkt hat eine Farbgröße',
GeneralGoods: "Gewöhnliche Waren",
Ausgewählt: 'Ausgewählt',
RestorePurchase: 'Kauf fortsetzen',
Buy_ElinkInvoice_Enterprise_Edition_OneUser: 'Buy Invoicing Enterprise Edition 1-Benutzer, permanent',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users: 'Invoicing Enterprise Edition kaufen, unbegrenzter Benutzer und Anzahl von Geräten, permanent',
Einkauf: 'Kaufen ... bitte haben Sie etwas Geduld ...',
Gültigkeitsdatum: 'Gültigkeit',
Makedate: "Produktionsdatum",
Charge: 'Charge',
CheckVersion: 'Version prüfen',
Please_set_this_ip_address_on_App: 'Bitte stellen Sie diese IP-Adresse in der APP oder die IP-Adresse des Computers ein',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Öffnen Sie diese Verbindung im Browser (verbunden mit demselben WiFi) Computer oder Mobiltelefon',
CheckVersion: 'Version prüfen',
You_need_to_purchase: 'Sie haben noch nicht gekauft. Bitte fügen Sie WeChat zu Elink9988 hinzu. E-Mail: bvbuy@qq.com',
Thank_for_your_purchase: "Sie haben bereits gekauft",
New_version_available: 'Es gibt eine neue Version',
Is_the_latest_version: 'ist die neueste Version',
    please:'Bitte',
input:'Eingang',
wrong:'falsch',
Verifycode:'Code überprüfen',
Upload:'Hochladen',
Download:'Herunterladen',
You_need_to_purchase_to_continue_use:'Sie müssen kaufen, um weiter verwenden zu können',
CheckBuy:'Kauf prüfen',
Exists:'Existiert',
NetworkUnavailable:'Netzwerk nicht verfügbar',
Today:'Heute',
Yesterday:'Gestern',
ThisMonth:'Diesen Monat',
LastMonth:'Im vergangenen Monat',
nickname:'Spitzname',
storeName:'Name des Geschäfts',
BuyStandAlone:'Stand-Alone-Version kaufen',
PermissionDenied:'Zugang verweigert',
Boss:'Boss',
    login:'Anmeldung',
operate:'Arbeiten',
register:'Registrieren',
username:'Nutzername',
password:'Passwort',
User:'Nutzer',
ok:'OK',
back:'Zurück',
success:'Erfolg',
fail:'Scheitern',
cancel:'Stornieren',
add:'Hinzufügen',
edit:'Bearbeiten',
delete:'Löschen',
refresh:'Aktualisierung',
close:'Schließen',
cancel:'Stornieren',
return:'Rückkehr',
ElinkInvoice:'Elink-Rechnung',
Purchase:'Kauf',
BaseData:'Basisdaten',
Sell:'Verkaufen',
PurchaseReturns:'Kaufretouren',
SellReturns:'Verkaufen Sie Renditen',
Inventory:'Inventar',
Statistics:'Statistiken',
Receivable:'Fordern',
Payable:'Zahlbar',
Orders:'Aufträge',
StockTransfer:'Umlagerung',
StockRecall:'Lager Rückruf',
Customer:'Kunde',
Supplier:'Lieferant',
Warehouse:'Warenhaus',
Color:'Farbe',
Size:'Größe',
Category:'Kategorie',
Category2:'Kategorie2',
Product:'Produkt',
Account:'Konto',
AccountType:'Kontotyp',
Staff:'Mitarbeiter',
typeone:'Kategorie',
typetwo:'Unterkategorie',
ProductName:'Produktname',
Specification:'Spezifikation',
Barcode:'Barcode',
Buyprice:'Kaufpreis',
Sellprice:'Verkaufspreis',
Wholesaleprice:'Großhandelspreis',
Currentstock:'Aktueller Lagerbestand',
Unit:'Einheit',
Initstock:'Init Lager',
Parameter:'Parameter',
Remark:'Anmerkung',
Supplier:'Lieferant',
Customer:'Kunde',
Staff:'Mitarbeiter',
Receivable:'Fordern',
payable:'zahlbar',
Receipts:'Quittungen',
Paid:'Bezahlt',
Preferential:'Bevorzugt',
DateDay:'Datum',
OrderNum:'Bestellnummer',
Name:'Name',
UserName:'Nutzername',
IdNum:'ID Nummer',
BirthDay:'Geburtstag',
SEX:'Sex',
Female:'Weiblich',
Male:'Männlich',
Select:'Wählen',
Address:'Adresse',
Phone:'Telefon',
Email:'Email',
CardNum:'Kartennummer',
Price:'Preis',
QTY:'Menge',
SupplierCategory:'Lieferantenkategorie',
CustomerCategory:'Kundenkategorie',
Power:'Leistung',
Role:'Rolle',
save:'sparen',
image:'Bild',
search:'Suche',
Year:'Jahr',
Month:'Monat',
Day:'Tag',
Total:'Gesamt',
WorkReport:'Arbeitsbericht',
Leave:'Verlassen',
CheckIn:'Check-In',
Announcement:'Ankündigung',
Approval:'Die Genehmigung',
Tracking:'Verfolgung',
Bill:'Rechnung',
OrdersDetail:'Auftragsdetail',
Expense:'Aufwand',
Income:'Einkommen',
Userfor:'Benutzerfür',
Amount:'Menge',
Title:'Titel',
News:'Nachrichten',
SelectFile:'Datei aussuchen',
Content:'Inhalt',
Cost:'Kosten',
ApprovalUser:'Genehmigungsbenutzer',
ApprovalStatus:'Freigabestand',
ApprovalRemark:'Genehmigungshinweis',
ApprovalDate:'Datum der Genehmigung',
SubmitDate:'Abgabetermin',
Status:'Status',
FromDateTime:'Ab Datum Uhrzeit',
ToDateTime:'Datum Datum',
Subject:'Gegenstand',
Latitude:'Breite',
Longitude:'Längengrad',
Print:'Drucken',
DataTrans:'DataTrans',
OA:'OA',
Setting:'Rahmen',
Help:'Hilfe',
ScanOpenInPhone:'Scannen im Telefon öffnen',
Building:'Gebäude',
Room:'Zimmer',
HotelCheckIn:'Check-In',
CheckOut:'Auschecken',
Hotel:'Hotel',
Checkintime:'Check-in Zeit',
Checkouttime:'Abreisezeit',
Deposit:'Anzahlung',
Cost:'Kosten',
RoomNum:'Zimmernummer',
Rent:'Miete',
costday:'Costday',
rent:'Miete',
waternum:'Wassergrad',
electricnum:'Elektrischer Grad',
gasnum:'Gasgrad',
watercost:'Wasser kosten',
electriccost:'elektrische Kosten',
gascost:'Gaskosten',
cleaningcost:'Reinigungskosten',
networkcost:'Netzwerkkosten',
tvcost:'TV kostet',
managecost:'Kosten verwalten',
othercost:'andere Kosten',
totalcost:'Gesamtkosten',
remark:'Anmerkung',
addtime:'Zeit hinzufügen',
OpenInBrowser:'Im Browser öffnen',
InventoryProfit:'Inventargewinn',
InventoryLoss:'Inventarverlust',
Buy:'Kaufen',



Refresh:'Aktualisieren',
Add:'Hinzufügen',
Search:'Suchen',
Records:'Einträge',
}



// WEBPACK FOOTER //
// ./src/lang/de.js